import { render, staticRenderFns } from "./incomeStockMovementEditPage.vue?vue&type=template&id=33e0488a&"
import script from "./incomeStockMovementEditPage.vue?vue&type=script&lang=ts&"
export * from "./incomeStockMovementEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports